import { render } from "./ThinkTankPost.vue?vue&type=template&id=fb2f1a2c&scoped=true"
import script from "./ThinkTankPost.vue?vue&type=script&lang=js"
export * from "./ThinkTankPost.vue?vue&type=script&lang=js"

import "./ThinkTankPost.vue?vue&type=style&index=0&id=fb2f1a2c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fb2f1a2c"

export default script